import { TOUR_TYPE__NAVIGATED_TOUR } from 'app/shared/help_and_information/tours/TourService';
import {
    genericSearchTagsForNewImsItems,
    HelpDetails,
} from 'app/shared/help_and_information/HelpRegistry';
import {
    NAV_TARGET_MANAGE_TAB,
    NAV_TARGET_OVERVIEW,
} from 'app/shared/internal_navigation/nav_targets';
import { ManagePageService } from 'app/overview/manage/service/ManagePageService';
import { IMS_TYPE__IP_DEVICE } from 'app/shared/collections/ip_device';

export const createIpDeviceTour: HelpDetails = {
    key: 'create-ip-device-tour',
    header: 'Creating an IP Device',
    quickStartGuideSearchText: 'using-bulk-edit-mode#adding-an-ip-device-1',
    tags: ['IP Device'],
    hiddenTags: genericSearchTagsForNewImsItems('IP device'),
    description: 'This tutorials shows you how to create a new IP Device in IMS',
    tourType: TOUR_TYPE__NAVIGATED_TOUR,
    navigateTo: [NAV_TARGET_OVERVIEW, NAV_TARGET_MANAGE_TAB],
    innerTourSteps: [
        {
            placement: 'bottom',
            target: '#overview_tab__manage',
            content: `First, navigate to the Manage Tab of IMS.`,
        },
        {
            placement: 'bottom',
            target: '#manage-all-ipdevice-add-button',
            content: `To create a new IP Device, tap the New IP Device button.`,
            onShow: () => {
                (
                    (window as any).services.managePageService as ManagePageService
                ).onPlusButtonClicked(IMS_TYPE__IP_DEVICE);
            },
            xOffset: -20,
        },
        {
            placement: 'right',
            target: 'ip-device-body button.dash-confirm-btn',
            content: `
                To save a new IP Device, fill out the required details and tap the Create button.
                To learn about editing an IP Device, start the 'Editing an IP Device' tour.
            `,
            yOffset: -20,
        },
    ],
};
